// 路径配置
var urlConfig = {
    erp: '/erp',
    authority: '/authority',
    pos: '/pos'
}
export default urlConfig


// WEBPACK FOOTER //
// ./src/config/urlConfig.js